import { useCallback, useRef } from 'react'

const useGanttScrollSync = () => {
  const headerScrollRef = useRef<HTMLDivElement>(null)
  const bodyScrollRef = useRef<HTMLDivElement>(null)
  const footerScrollRef = useRef<HTMLDivElement>(null)
  const timelineCanvasRef = useRef<HTMLDivElement>(null)

  const syncHorizontalScroll = useCallback((scrollLeft: number) => {
    if (headerScrollRef.current) headerScrollRef.current.scrollLeft = scrollLeft
    if (footerScrollRef.current) footerScrollRef.current.scrollLeft = scrollLeft
    if (
      bodyScrollRef.current &&
      bodyScrollRef.current.scrollLeft !== scrollLeft
    ) {
      bodyScrollRef.current.scrollLeft = scrollLeft
    }
  }, [])

  return {
    headerScrollRef,
    bodyScrollRef,
    footerScrollRef,
    timelineCanvasRef,
    syncHorizontalScroll
  }
}

export default useGanttScrollSync
